import { FC, memo } from 'react';

import { useConnectQuickBooksButton } from './ConnectQuickBooksButton.hooks';
import { StyledButton } from './ConnectQuickBooksButton.styles';
import { ConnectQuickBooksButtonProps } from './ConnectQuickBooksButton.types';

export const ConnectQuickBooksButton: FC<ConnectQuickBooksButtonProps> = memo((props) => {
    const { size = 'medium', disabled, onClick } = props;
    const { width, height, backgroundImage, backgroundImageHover } = useConnectQuickBooksButton(size);

    return (
        <StyledButton
            noPadding
            onClick={onClick}
            color='brandQBO80'
            size={size}
            $width={width}
            $height={height}
            $backgroundImage={backgroundImage}
            $backgroundImageHover={backgroundImageHover}
            disabled={disabled}
        />
    );
});

ConnectQuickBooksButton.displayName = 'ConnectQuickBooksButton';
